import { render, staticRenderFns } from "./MessageAskLife.vue?vue&type=template&id=77aeb03e&scoped=true&"
import script from "./MessageAskLife.vue?vue&type=script&lang=js&"
export * from "./MessageAskLife.vue?vue&type=script&lang=js&"
import style0 from "./MessageAskLife.vue?vue&type=style&index=0&id=77aeb03e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77aeb03e",
  null
  
)

export default component.exports